import en from './en.json';

const modules = { en };

module.exports = modules;
